import {Injectable, signal, WritableSignal} from '@angular/core';
import {User} from '../../graphql/generated';
import {GraphqlService} from './graphql.service';
import {getUserByIdQuery} from '../../graphql/queries/user';
import {UserDataFetchError} from '../exceptions/exceptions';
import {DatabaseService} from './database.service';
import {MessagingService} from './messaging.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  user: WritableSignal<User> = signal<User>({} as User);

  constructor(
    private graphqlService: GraphqlService,
    private dataService: DatabaseService,
    private messagingService: MessagingService
  ) {
  }

  async getUserById(): Promise<User> {
    try {
      const response = await this.graphqlService.runQuery(getUserByIdQuery);

      return response.get_user_json;
    } catch (error) {
      throw new UserDataFetchError('Error fetching user data');
    }
  }

  async getUsers() {
    return await this.dataService.getUsers();
  }

  async getBranchUsers(branchId: string) {
    const users = await this.getUsers();
    return users.filter((user: User) => user.branches.some((branch) => branch.id === branchId));
  }

  async getDBUserById(id: string) {
    return await this.dataService.getUserById(id);
  }

  getUserFromLocalStorage(): any {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }

  setUser(user: User) {
    localStorage.setItem('user', JSON.stringify(user));
    this.user.set(user);
    this.messagingService.requestPermission(user.id);
  }
}
